module.exports = __webpack_public_path__ + "components/country-flag/static/tc-9fb03dc7bc73480adc8e2a993a6aab6e.svg";